import dayjs from "dayjs";

export function formatDateToMonthYear(dateStr: string) {
  // Split the date string into day, month, and year
  const [day, month, year] = [dayjs(dateStr).day(), dayjs(dateStr).month(), dayjs(dateStr).year()];

  // Array of month names
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  // Convert month number to month name (subtract 1 since array is 0-based)
  const monthName = monthNames[month];

  // Return formatted string
  return `${monthName} ${year}`;
}
